import { useState } from 'react';

export const usePristineCard = () => {
  const [editableCardPristineStates, setEditableCardPristineStates] = useState<
    Record<string, boolean>
  >({});
  const [isCreatingNew, setIsCreatingNew] = useState(false);
  const [newCardIsPristine, setNewCardIsPristine] = useState(true);

  const anyEditableCardDirty = Object.values(editableCardPristineStates).some(
    (isPristine) => !isPristine,
  );
  const isNewCardDirty = !newCardIsPristine && isCreatingNew;
  const isPristine = !anyEditableCardDirty && !isNewCardDirty;

  return {
    setEditableCardPristineStates,
    isCreatingNew,
    setIsCreatingNew,
    setNewCardIsPristine,
    isPristine,
  };
};
